export default __webpack_public_path__ + "f6f159ceefcf0b4053ca747bd95b6898.png";